var redirectForm = function() {
  var accForm = document.querySelector('[action*="/account"]');
  if (accForm) {
    accForm.addEventListener('submit', function(event){
      if (window.BOLD && BOLD.recurring_orders) {
        event.preventDefault();
        var form = event.target;
        var xhr = new XMLHttpRequest(); 
        xhr.open("POST", form.action );
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4 && xhr.status < 400) {
            if (xhr.responseURL !== form.action && !/\/checkouts\//.test(xhr.responseURL)) {
              window.location.href = xhr.responseURL;
            } else {
              window.location.href = "/cart";
            }
          }
        };
        xhr.send(new FormData(form))
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', redirectForm)